var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWishlistInactive = function SvgWishlistInactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    "data-name": "Group 1979",
    transform: "translate(-206 -2159)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    "data-name": "Rectangle 1654",
    rx: 8,
    transform: "translate(206 2159)"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.514 2170.853a6.017 6.017 0 0 1 8.687 0 6.461 6.461 0 0 1 0 8.947l-8.743 9a.634.634 0 0 1-.915 0l-8.743-9a6.461 6.461 0 0 1 0-8.947 6.017 6.017 0 0 1 8.687 0l.513.529Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#414e5f",
    d: "M221.143 2170.5a4.526 4.526 0 0 0-3.268 1.398c-1.835 1.89-1.835 4.967 0 6.857l8.125 8.368 8.125-8.368c1.835-1.89 1.835-4.967 0-6.857a4.526 4.526 0 0 0-3.268-1.398 4.526 4.526 0 0 0-3.267 1.398l-1.59 1.638-1.59-1.638a4.526 4.526 0 0 0-3.267-1.398m0-1.5c1.572 0 3.144.618 4.343 1.853l.514.53.514-.53a6.017 6.017 0 0 1 8.687 0c2.399 2.47 2.399 6.476 0 8.947l-8.744 9.005a.634.634 0 0 1-.914 0l-8.744-9.005c-2.399-2.47-2.399-6.476 0-8.947a6.034 6.034 0 0 1 4.344-1.853"
  })))));
};
export default SvgWishlistInactive;